<template>
	<div v-editable="blok">
		<h3
			class="
				font-secondary
				font-bold
				typo-body-m
				mb-1
				md:mb-2
				mt-4
			"
		>
			{{ blok.title }}
		</h3>
		<ul>
			<StoryblokComponent
				v-for="item in blok.listOfIngredients"
				:key="item._uid"
				:blok="item"
			/>
		</ul>
	</div>
</template>

<script setup lang="ts">
	import type {IngredientsListStoryblok} from '@/storyblok/types';

	interface Props {
		blok: IngredientsListStoryblok
	}

	defineProps<Props>();
</script>
